import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { setTagManagerIds } from "../slices/vehicleSlice";

export const GoogleTagManager = () =>  {
    window.dataLayer = window.dataLayer || [];
    const tagManagerIds = useSelector(setTagManagerIds);
    useEffect(() => {
        if (!tagManagerIds || tagManagerIds.length === 0) {
            return;
        }

        tagManagerIds.forEach((id) => {
            const script = document.createElement("script");
            script.innerHTML = `
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', ${JSON.stringify(id)});
      `;
            document.head.appendChild(script);
        });

        return () => {
            tagManagerIds.forEach((id) => {
                const script = document.querySelector(`script[src*='${id}']`);
                if (script) {
                    document.head.removeChild(script);
                }
            });
        };
    }, [tagManagerIds]);

    if (!tagManagerIds || tagManagerIds.length === 0) {
        return null;
    }
};
